// URL shapes (plan §4.2, §4.4 as amended by ADR-017), shared by the adapter, the client and the OpenAPI emitter.
export const paths = {
  command: (name: string) => `/v1/commands/${name}`,
  query: (name: string) => `/v1/queries/${name}`,
} as const;

/** Headers the router reads or writes, lower-case as Node sees them. */
export const headers = {
  idempotencyKey: 'idempotency-key',
  replayed: 'idempotent-replayed',
  dryRun: 'radish-dry-run',
} as const;
